import logo from './logo.svg';
import './App.css';
import ColorGrading from './components/ColorGrading';

function App() {
  return (
    <div className="App">
      <ColorGrading/>
    </div>
  );
}

export default App;
